import { Component } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IConfirmPaymentTransferData } from 'src/app/shared/interfaces';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-confirm-transfer-payment',
  templateUrl: './confirm-transfer-payment.component.html',
  styleUrls: ['./confirm-transfer-payment.component.scss']
})
export class ConfirmTransferPaymentComponent {

  /**
   *
   */
  constructor(public dialogRef: MatDialogRef<ConfirmTransferPaymentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IConfirmPaymentTransferData) {
    
    
  }

}
